import $ from 'wee-dom';
import $events from 'wee-events';
import { _win } from 'core/variables';
import CalcSlide from './calcSlide';

export default class CalcChart {
    constructor() {
        this.sliders = [];

        $('.calculator-earnings_rate').each((el) => {
            if ($(el).hasClass('-js-no-show')) {
                $(el, '.calculator-earnings_children').remove($(el));
            }    

            if (this.getParams()) {
                const ref = $('.js-calculator_range-slide', $(el)).data('ref');

                if (this.getParams()[ref.replace(' ', '_')]) {
                    const element = new CalcSlide(el, Number(this.getParams()[ref.replace(' ', '_')]));
                    this.sliders.push(element);
                } else {
                    const element = new CalcSlide(el);
                    this.sliders.push(element);
                }

            } else {
                const element = new CalcSlide(el);
                this.sliders.push(element);
            }   
        });

        this.init();
    }

    getParams() {
        const url = _win.location.href;
        let parser = document.createElement('a');
        parser.href = url;
        let query = parser.search.substring(1);
        let vars = query.split('&');
        
        if (vars != '') {
            let params = {};

            for (let i = 0; i < vars.length; i++) {
                let pair = vars[i].split('=');
                params[pair[0]] = decodeURIComponent(pair[1]);
            }
            return params;
        } else {
            return null;
        }
    };

    isMobile() {
        return window.innerWidth < 1001;
    }

    initMobile() {
        const scope = this;
        const $sectionNav = $('.section-nav').last();
        scope.canJump = true;
        scope.showActiveBar = false;

        $events.on({
            window: {
                scroll() {
                    const sectionPos = '0px';
                    const curScroll = window.scrollY;
                    const sectionNavTop = $sectionNav[0].offsetTop;

                    if (curScroll <= $('.hero-text')[0].offsetHeight + 200) {
                        if ($sectionNav.hasClass('-lock')) {
                            $sectionNav.removeClass('-lock')
                                .css('top', '0');
                            $('.section-nav__item').removeClass('-active');
                            $('.section-nav-spacer').removeClass('-open');
                        }
                    } else if (curScroll >= sectionNavTop + 20) {
                        if (! $sectionNav.hasClass('-lock')) {
                            $sectionNav.addClass('-lock');
                            $('.section-nav-spacer').addClass('-open');
                        }

                        if ($sectionNav.css('top') !== sectionPos) {
                            $sectionNav.css('top', sectionPos);
                        }
                    }
                },
            },
        }, {
            namespace: '.full-page-earnings-calc js-controller',
        });
    }

    initDesktopScroll() {
        const sectionNavUseParent = $('.section-nav').prev().length === 0;
        const $sectionNavPrev = sectionNavUseParent
            ? $('.section-nav').parent()
            : $('.section-nav').prev();
        const $sectionNav = $('.section-nav').first();

        $events.on({
            window: {
                scroll() {
                    const headerBottom = $('.header')[0].offsetTop + $('.header')[0].offsetHeight;
                    const sectionPos = `${headerBottom}px`;
                    const curScroll = window.pageYOffset;
                    const sectionNavTop = $sectionNav[0].offsetTop;
                    const sectionNavPrevTop = $sectionNavPrev[0].offsetTop;
                    const sectionSpaceOffset = $sectionNav.hasClass('-lock')
                        ? $sectionNav[0].offsetHeight
                        : 0;
                    const sectionNavBasePos = sectionNavUseParent
                        ? sectionNavPrevTop
                        : sectionNavPrevTop + $sectionNavPrev[0].offsetHeight - sectionSpaceOffset;

                    if (curScroll + headerBottom <= sectionNavBasePos + 30) {
                        if ($sectionNav.hasClass('-lock')) {
                            $sectionNav.removeClass('-lock')
                                .css('top', 'auto');
                            $('.section-nav__item').removeClass('-active');
                            $('.section-nav-spacer').removeClass('-open');
                        }
                    } else if (curScroll + headerBottom >= sectionNavTop + 30) {
                        if (! $sectionNav.hasClass('-lock')) {
                            $sectionNav.addClass('-lock');
                            $('.section-nav-spacer').addClass('-open');
                        }

                        if ($sectionNav.css('top') !== sectionPos) {
                            $sectionNav.css('top', sectionPos);
                        }
                    }
                },
            },
        });
    }

    initDesktop() {
        this.canJump = true;
        this.showActiveBar = false;

        if (! this.homeSlider) {
            this.initDesktopScroll();
        }
    }

    init() {
        this.homeSlider = $('.home__calculator').length > 0;

        if (this.isMobile()) {
            if (! this.homeSlider) {
                this.initMobile();
            }
        } else {
            this.initDesktop();
        }

        this.maxValue = 0;
        this.currentValue = 0;

        $('.calculator-earnings_summary-amount').text(`${Math.round(this.setTotal()).toLocaleString('en-US')}`);
        this.setMaxValue();
        this.updateGraph(this.isMobile(), this.getPercent());
    }

    updateGraph(isMobile, percent) {
        const graphClass = isMobile
            ? '.calculator-earnings_bar-progress'
            : '.calculator-earnings_body';

        const $graphBody = $(graphClass);

        if (! isMobile) {
            const radius = $graphBody[0].r.baseVal.value;
            const circumference = radius * 2 * Math.PI;
            const offset = circumference - (percent / 100) * circumference;
            $graphBody.css('stroke-dashoffset', offset);
        } else {
            $graphBody.css('width', `${percent}%`);
        }

        $(':givebackTotal').text(`Giveback total $${this.setTotal().toLocaleString('en-US')}`);
    }

    getPercent() {
        const presentVal = this.sliders.reduce((prev, curr) => {
            if (curr.isActive) {
                return prev + Number(curr.value());
            }

            return prev;
        }, 0);

        const maxValue = this.sliders.reduce((prev, curr) => prev + curr.maxValue, 0);

        const percent = (Number(presentVal) / Number(maxValue)) * 100;

        return percent <= 95 ? percent : 95;
    }

    setMaxValue() {
        this.maxValue = this.sliders.reduce((prev, curr) => prev + curr.maxValue, 0);
    }

    setTotal() {
        return this.sliders.reduce((prev, curr) => (
            curr.isActive ? prev + curr.getTotal() : prev
        ), 0);
    }
}
